$(document).ready(function () {
    $('form[name="email-dealer-details"]').on('submit', function (e) {
        e.preventDefault();
        $(this).validate();

        // only proceed when fields are valid
        if ($(this).valid()) {
            // get wrapper element
            var wrapper = $(this).parent();

            // construct parameters
            var url = $(this).data('url');
            var data = {
                email: $(this).find('input[name="Email"]').val(),
                department: $(this).find('input[name="Department"]').val()
            }
            data = JSON.stringify(data);

            var response = $.ajax({
                type: "POST",
                url: url,
                data: data,
                contentType: "application/json"
            });

            response.done(function (response) {
                wrapper.html(response.rawHtml);
            });

            response.fail(function (response) {
                // default error response
                wrapper.html("<div> An unknown error occured while processing your enquiry. Please contact support. </div>");
            });
        }
    });
});